import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Obtener idioma guardado en localStorage o detectar del navegador
    const savedLanguage = localStorage.getItem('rtb-collect-language');
    if (savedLanguage) {
      return savedLanguage;
    }
    // Detectar idioma del navegador
    const browserLanguage = navigator.language || navigator.userLanguage;
    return browserLanguage.startsWith('es') ? 'es' : 'en';
  });

  useEffect(() => {
    // Guardar idioma en localStorage
    localStorage.setItem('rtb-collect-language', language);
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

